var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandelsbanken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 82.1",
    style: {
      enableBackground: "new 0 0 800 82.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003399"
    },
    d: "M16.8,44.4v36.1H0V0h16.8v30.5h31.4V0H65v80.5H48.2V44.4H16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003399"
    },
    d: "M127.5,68.8c0,7.1,1.6,8.6,3.5,9.3v2.4H114c-0.9-2.8-1.1-3.7-1.5-7.1c-3.6,3.7-8.6,8.6-19.3,8.6 c-9,0-18.2-5-18.2-17.4c0-11.7,7.4-17.6,17.4-19.1l14.1-2.1c2.5-0.3,5.5-1.3,5.5-4.7c0-6.6-6.3-7-10.3-7c-7.8,0-9.2,4.8-9.6,8.3H77 c1.8-18.3,14.5-20.9,26.7-20.9c8.4,0,23.8,2.6,23.8,17.3V68.8L127.5,68.8z M112.1,51.5c-1.6,1.2-4.1,2.2-10.7,3.3 c-5.8,1-10.7,2.5-10.7,9c0,5.5,4.3,7.2,7.3,7.2c7,0,14-4.5,14-11.8V51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003399"
    },
    d: "M194.3,80.5h-15.7V44.3c0-4.4-0.2-11.8-10.2-11.8c-7,0-12.3,4.7-12.3,13.8v34.2h-15.7V20.9h15v8.7 h0.2c2.1-3.6,6.6-10.3,17.9-10.3c11.7,0,20.7,6.8,20.7,20L194.3,80.5L194.3,80.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003399"
    },
    d: "M262.3,80.5h-15.4V73h-0.2c-3.8,6.7-10.8,9.1-17.3,9.1c-17.7,0-25.1-15.7-25.1-32.1 c0-20.6,11.7-30.7,24.8-30.7c10.1,0,14.8,5.5,17.3,9.3h0.2V0h15.7L262.3,80.5L262.3,80.5z M233.3,69.2c10,0,13.9-8.3,13.9-17.2 c0-9.5-2.7-19.2-13.5-19.2c-10,0-13.3,8.9-13.3,18.3C220.4,58.2,223.2,69.2,233.3,69.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003399"
    },
    d: "M326.4,63c-4.1,14.4-16,19.1-26.2,19.1c-16.8,0-29.7-8.1-29.7-32.6c0-7.2,2.5-30.2,28.6-30.2 c11.8,0,28,5.6,28,32.9v2.8h-40.9c0.4,4.5,1.3,14.6,14,14.6c4.4,0,8.9-2.2,10.1-6.5L326.4,63L326.4,63z M310.9,44.7 c-0.9-9.6-7.1-12.6-12.1-12.6c-7.4,0-11.3,4.7-12.2,12.6H310.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003399"
    },
    d: "M352.5,80.5h-15.7V0h15.7V80.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003399"
    },
    d: "M400.2,39c-0.7-3.8-2-7.8-10.5-7.8c-8.5,0-9.6,3.3-9.6,5.8c0,9.4,37.3,2.6,37.3,24.6 c0,17.4-16.8,20.5-26.1,20.5c-13.6,0-28.3-4.7-28.7-20.6h16.1c0,5,3.1,8.7,13,8.7c8.1,0,10-3.9,10-6.2c0-10-37-2.5-37-24.8 c0-8.7,5.5-20,24.1-20c11.7,0,25.6,2.9,26.8,19.7L400.2,39L400.2,39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003399"
    },
    d: "M442.9,28.6h0.2c2.5-3.8,7.2-9.3,17.3-9.3c13.1,0,24.8,10.1,24.8,30.7c0,16.4-7.4,32.1-25.1,32.1 c-6.5,0-13.5-2.4-17.3-9.1h-0.2v7.5h-15.4V0h15.7V28.6z M455.7,32.9c-10.8,0-13.5,9.6-13.5,19.2c0,8.9,3.9,17.2,13.9,17.2 c10.1,0,12.9-11,12.9-18.1C469,41.7,465.6,32.9,455.7,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003399"
    },
    d: "M543.3,68.8c0,7.1,1.6,8.6,3.5,9.3v2.4h-16.9c-0.9-2.8-1.1-3.7-1.5-7.1c-3.6,3.7-8.6,8.6-19.3,8.6 c-9,0-18.2-5-18.2-17.4c0-11.7,7.4-17.6,17.4-19.1l14.1-2.1c2.5-0.3,5.5-1.3,5.5-4.7c0-6.6-6.3-7-10.3-7c-7.9,0-9.2,4.8-9.6,8.3 h-15.1c1.8-18.3,14.5-20.9,26.7-20.9c8.4,0,23.8,2.6,23.8,17.3L543.3,68.8L543.3,68.8z M528,51.5c-1.6,1.2-4.1,2.2-10.7,3.3 c-5.8,1-10.7,2.5-10.7,9c0,5.5,4.3,7.2,7.3,7.2c7,0,14-4.5,14-11.8L528,51.5L528,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003399"
    },
    d: "M610.2,80.5h-15.7V44.3c0-4.4-0.2-11.8-10.2-11.8c-7,0-12.3,4.7-12.3,13.8v34.2h-15.7V20.9h15v8.7 h0.2c2.1-3.6,6.6-10.3,17.9-10.3c11.7,0,20.7,6.8,20.7,20V80.5L610.2,80.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003399"
    },
    d: "M639.8,80.5h-15.7V0h15.7v43.5l19.7-22.6h19.3L657.7,44l21.6,36.6h-18.8l-14.2-25.6l-6.5,6.7V80.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003399"
    },
    d: "M736.1,63c-4.1,14.4-16,19.1-26.2,19.1c-16.8,0-29.7-8.1-29.7-32.6c0-7.2,2.5-30.2,28.6-30.2 c11.8,0,28,5.6,28,32.9v2.8h-40.9c0.4,4.5,1.3,14.6,14,14.6c4.4,0,8.9-2.2,10.1-6.5L736.1,63L736.1,63z M720.6,44.7 c-0.9-9.6-7.1-12.6-12.1-12.6c-7.4,0-11.3,4.7-12.2,12.6H720.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003399"
    },
    d: "M800,80.5h-15.7V44.3c0-4.4-0.2-11.8-10.2-11.8c-7,0-12.3,4.7-12.3,13.8v34.2h-15.7V20.9h15v8.7 h0.2c2.1-3.6,6.6-10.3,17.9-10.3c11.7,0,20.7,6.8,20.7,20V80.5L800,80.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandelsbanken);
export default __webpack_public_path__ + "static/media/handelsbanken.97866b794f8126e882aeabc6f03c7340.svg";
export { ForwardRef as ReactComponent };